import React from "react";
import { Table, Button } from "reactstrap";
import { RiDeleteBin5Line } from "react-icons/ri";
import { TiArrowBack } from "react-icons/ti";
import noavatar from "../../../assets/img/noavatar.png";
import { useNavigate } from "react-router";
import { VscTerminalLinux } from "react-icons/vsc";
import { deleteData } from "../../../api/method";

const username = localStorage.getItem("username");

function TableCart({ args, data, onRemove, onAdd, getCartByDel }) {
  const navigate = useNavigate();

  const handleDelete = async () => {
    try {
      const res = await deleteData(`/api/Cart/cart/${username}`);
      console.log(res);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="w-75">
      <Table className="table_cart">
        <thead>
          <tr className="fs-20 fw-bold border_top">
            <th className="cart_item">Product</th>
            <th className="cart_price">Price</th>
            <th className="cart_quantify">Quantity</th>
            <th></th>
          </tr>
        </thead>

        <tbody>
          {data?.length > 0 ? (
            data?.map((item) => (
              <tr className="border_top" key={item.id}>
                <td className="cart_item">
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="img_cart">
                      <img
                        src={
                          `${
                            process.env.REACT_APP_URL_IMAGE + item.product.image
                          }` || noavatar
                        }
                        alt="product"
                        width="100%"
                        height="100%"
                      />
                    </div>

                    <div className="ms-3">
                      <p className="fs-20 mb-2 cart_item_name">
                        {item.product.name}
                      </p>
                      <p className="d-flex align-items-center fs-6 t-grey">
                        Dimension:
                        <span className="t-grey ms-2">
                          {item.product.dimension}ml
                        </span>
                      </p>
                    </div>
                  </div>
                </td>

                <td className="cart_price">
                  <p className="fs-6 fw-bold mb-1">
                    {(
                      (item.product.price * (100 - item.product.discount)) /
                      100
                    ).toLocaleString("vi")}
                    &#273;
                  </p>
                  <p className="price_sale_info fs-15 fw-bold">
                    {(item.product.price * 1).toLocaleString("vi")}&#273;
                  </p>
                </td>

                <td className="cart_quantify align-items-center">
                  <Button
                    className="btn_addsub"
                    onClick={() => onRemove(item.id)}
                  >
                    -
                  </Button>
                  <span className="mx-2">{item.quantity}</span>
                  <Button className="btn_addsub" onClick={() => onAdd(item.id)}>
                    +
                  </Button>
                </td>

                <td className="btn_del_cart">
                  <RiDeleteBin5Line
                    className="fs-4"
                    onClick={() => getCartByDel(item.id)}
                  />
                </td>
              </tr>
            ))
          ) : (
            <div className="border_top d-flex align-items-center flex-column w-100 py-5 justify-content-center">
              <VscTerminalLinux className="fs-1" />
              <p className="fs-24">No Product</p>
            </div>
          )}
        </tbody>
      </Table>

      <div className="d-flex justify-content-between mt-4">
        <Button
          className="btn_contine mt-2 d-flex align-items-center"
          onClick={() => navigate("/categories")}
        >
          <TiArrowBack className="me-1" /> Continue Shopping
        </Button>

        <Button
          className="btn_contine mt-2 d-flex align-items-center"
          onClick={handleDelete}
        >
          <RiDeleteBin5Line className="me-1" /> Delete All
        </Button>
      </div>
    </div>
  );
}

export default TableCart;
